import { useTranslation } from 'react-i18next';
import { TradingLoadingButton } from '@trading-ui/core';
import TradingSelect from '@trading-ui/select';

import useAppStore from '@/store/app.store';

import type { MoeveUserPayload } from '@/interfaces';

import { FormUtils } from '../../utils/form.utils';

import * as styles from './Form.css';

type Props = {
  form: MoeveUserPayload;
  isSubmitting: boolean;
  errors: Partial<Record<keyof MoeveUserPayload, string>>;
  updateRole: (value: string) => void;
  updateCompanies: (value: Array<{ id: number; value: string; label: string }>) => void;
  handleSubmit: () => void;
};

export default function MoeveUserForm({
  form,
  isSubmitting,
  errors,
  updateRole,
  updateCompanies,
  handleSubmit,
}: Props) {
  const { t } = useTranslation();
  const companies = useAppStore((state) => state.masters.companies);

  return (
    <div className={styles.formContainer}>
      <TradingSelect
        label={t('settings.moeveActionsTab.moeveUserModal.roleLabel')}
        value={form.role}
        onChange={(value) => updateRole(value!)}
        options={['MOEVE_ADMIN', 'MANAGER', 'USER']}
        disableClearable
        error={!!errors.role}
        helperText={errors.role}
      />
      <TradingSelect
        label={t('settings.moeveActionsTab.moeveUserModal.companyLabel')}
        value={form.companies}
        onChange={(value) => updateCompanies(value ?? [])}
        options={FormUtils.getCompaniesOptions(companies)}
        error={!!errors.companies}
        helperText={errors.companies}
        disabled={form.role === 'MOEVE_ADMIN'}
        multiple
      />
      <TradingLoadingButton
        label="Submit"
        handleClick={handleSubmit}
        className={styles.button}
        loading={isSubmitting}
      />
    </div>
  );
}
